import React, { ReactElement } from 'react';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { useLinguiInit } from '../i18n';
import { Helmet } from 'react-helmet';
import useScrollRestoration from '../lib/useScrollRestoration';

interface TemplateProps {
    children: ReactElement;
    pageContext: any;
}

const Template: React.FC<TemplateProps> = ({ children, pageContext }) => {
    let locale = pageContext?.locale;

    if (!locale && typeof window !== 'undefined') {
        const match = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
        locale = match?.[1] || 'uk'; // по умолчанию 'en'
    }
    useLinguiInit(locale);
    useScrollRestoration();
    return (
        <I18nProvider i18n={i18n}>
            <Helmet>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, viewport-fit=cover"
                />
            </Helmet>
            {children}
        </I18nProvider>
    );
};

export default Template;
